import { apiClient } from "../client";
import { nowAUSISO } from "@/utils/dateTime";
const ENDPOINTS = {
    LIST: "/quotes",
    BY_CONTACT: "/quotes/contact",
    BY_COMPANY_NAME: "/quotes/company-name",
    FROM_SITE: "/quotes/from-site",
    AWAITING_APPROVAL: "/quotes/awaiting-approval",
    IN_PROGRESS: "/quotes/in-progress",
};
export const quotesService = {
    // Get all quotes with filters
    getQuotes: (filters) => {
        const params = new URLSearchParams();
        if (filters?.contactId)
            params.append("contactId", filters.contactId);
        if (filters?.status)
            params.append("status", filters.status);
        if (filters?.quoteType)
            params.append("quoteType", filters.quoteType);
        if (filters?.search)
            params.append("search", filters.search);
        if (filters?.page)
            params.append("page", filters.page.toString());
        if (filters?.pageSize)
            params.append("pageSize", filters.pageSize.toString());
        return apiClient.get(`${ENDPOINTS.LIST}?${params.toString()}`);
    },
    // Get quotes for a specific contact
    getQuotesByContact: (contactId, status) => {
        const params = new URLSearchParams();
        if (status)
            params.append("status", status);
        return apiClient.get(`${ENDPOINTS.BY_CONTACT}/${contactId}?${params.toString()}`);
    },
    // Get quotes for a specific company (by company name)
    getQuotesByCompanyName: (companyName, status) => {
        const params = new URLSearchParams();
        if (status)
            params.append("status", status);
        return apiClient.get(`${ENDPOINTS.BY_COMPANY_NAME}/${encodeURIComponent(companyName)}?${params.toString()}`);
    },
    // Get single quote
    getQuote: (id) => apiClient.get(`${ENDPOINTS.LIST}/${id}`),
    // Create quote
    createQuote: (data) => apiClient.post(ENDPOINTS.LIST, data),
    // Create estimate from site
    createEstimateFromSite: (data) => apiClient.post(ENDPOINTS.FROM_SITE, data),
    // Update quote
    updateQuote: (id, data) => apiClient.put(`${ENDPOINTS.LIST}/${id}`, data),
    // Update quote status. When status is "declined", pass reasonForDecline to send ReasonForDecline to the API.
    updateQuoteStatus: (id, status, options) => apiClient.put(`${ENDPOINTS.LIST}/${id}/status`, {
        status,
        ...(status === "pending" && { sentDate: nowAUSISO() }),
        ...(options?.reasonForDecline != null &&
            options.reasonForDecline !== "" && {
            ReasonForDecline: options.reasonForDecline,
        }),
    }),
    // Copy quote
    copyQuote: (id) => apiClient.post(`${ENDPOINTS.LIST}/${id}/copy`),
    // Delete quote
    deleteQuote: (id) => apiClient.delete(`${ENDPOINTS.LIST}/${id}`),
    // Dashboard: quotes with status PENDING (awaiting approval)
    getQuotesAwaitingApproval: () => apiClient.get(ENDPOINTS.AWAITING_APPROVAL),
    // Dashboard: quotes with status INPROGRESS, newest first
    getQuotesInProgress: () => apiClient.get(ENDPOINTS.IN_PROGRESS),
};
